import React from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Modal } from 'react-bootstrap';
import SettingField from 'components/Fields/ReduxForm/SettingField';

import ModalHeader from 'components/Modal/ModalHeader';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import ItemHasRecipe from 'components/ItemHasRecipe';
import ListItemModal from 'components/ListItemModal';

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS,
} from 'actions/inventory/constants';
import SearchModal from 'components/Fields/ReduxForm/SearchModal';
import styles from './AddItemsModal.css';

const validate = (values, props) => {
  const { items } = values;
  const errors = {};
  const itemsErrors = [];

  if (items) {
    items.forEach((item, index) => {
      const itemErrors = {};
      if (!item.quantity && `${item.quantity}` !== '0') {
        itemErrors.quantity = 'Please enter a valid value';
        itemsErrors[index] = itemErrors;
      } else if (
        props.searchForm.namespace === NAMESPACE_INGREDIENTS &&
        parseFloat(item.quantity) < 0.01
      ) {
        itemErrors.quantity = 'Quantity must greater than or equal 0.01';
        itemsErrors[index] = itemErrors;
      }

      if (item.inStock === undefined) {
        items[index].inStock = 0;
      }
    });
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors;
  }
  return errors;
};

const nameField = props => {
  const { input } = props;

  return (
    <input
      {...input}
      defaultValue={input.value}
      readOnly
      className="form-control"
    />
  );
};

const nameFieldDisabled = props => {
  const { input } = props;

  const style = {
    color: '#ddd',
    background: '#fff',
    cursor: 'not-allowed',
  };

  return (
    <input
      style={style}
      {...input}
      defaultValue={input.value}
      readOnly
      className="form-control"
    />
  );
};

class AddItemsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openErrorAlert: false,
      selectValue: null,
      keyword: '',
      itemHasRecipe: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showAddItemsModal && !this.props.showAddItemsModal) {
      this.setState({ itemHasRecipe: false });
    }
  }

  render() {
    const {
      showAddItemsModal,
      addItems,
      itemOptionIsLoading,
      isItemAlreadyAdded,
      searchForm,
      handleSubmit,
      addTransferItemsForm,
      clickLinkIngredient,
    } = this.props;

    return (
      <Modal
        show={showAddItemsModal}
        backdrop="static"
        dialogClassName={styles.dialog}
        className={`${styles.modalitem}`}
      >
        <ModalHeader
          title={
            searchForm && searchForm.namespace === NAMESPACE_ITEMS
              ? 'Add Items'
              : 'Add Ingredients'
          }
        />
        <form onSubmit={handleSubmit(this._onSubmit)}>
          <Modal.Body className={styles.modalBody}>
            <div className={styles['warning-style']}>
              {this.state.openErrorAlert && (
                <div className="alert alert-danger">
                  <span
                    onClick={this._dismissError}
                    className={`glyphicon glyphicon-remove ${
                      styles['dismiss-warning-button']
                    }`}
                    aria-hidden="true"
                  />
                  <h5 className={`ml-30px`}>
                    Cannot add more{' '}
                    {searchForm && searchForm.namespace === NAMESPACE_ITEMS
                      ? 'items'
                      : 'ingredients'}{' '}
                    than current stock
                  </h5>
                </div>
              )}
            </div>
            <Field
              component={SearchModal}
              type="text"
              name="search-item"
              placeholder={
                searchForm && searchForm.namespace === NAMESPACE_ITEMS
                  ? 'Search items'
                  : 'Search ingredients'
              }
              options={addItems.itemOptions}
              onClickItem={this._selectOnChange}
              isHiddenSuggestion
              hasImproveModal
              onInputChange={this._selectOnInputChange}
              inputValue={this.state.selectValue}
              onMenuScrollToBottom={this._onSearchReachBottom}
              isHasMore={this._hasMore}
              isLoading={itemOptionIsLoading}
            />
            <ItemHasRecipe
              hasRecipe={this.state.itemHasRecipe}
              onClickIngredient={clickLinkIngredient}
            />
            {!this.state.selectValue && (
              <ListItemModal
                items={addItems.itemOptions}
                onSelectItem={this._selectOnChange}
                onMenuScrollToBottom={this._onSearchReachBottom}
                isHasMore={this._hasMore}
              />
            )}
            {isItemAlreadyAdded && (
              <div className={styles['warning-message-wrapper']}>
                <WarningMessage>
                  &nbsp;&nbsp;&nbsp;This{' '}
                  {searchForm && searchForm.namespace === NAMESPACE_ITEMS
                    ? 'items'
                    : 'ingredients'}{' '}
                  already added, go to{' '}
                  <a href="javascript:void(0)" onClick={this._onHide}>
                    <u>
                      <i>Transfer stock table</i>
                    </u>
                  </a>{' '}
                  to edit
                </WarningMessage>
              </div>
            )}
            {!this.state.itemHasRecipe && this.state.selectValue && (
              <FieldArray name="items" component={this._renderFieldArray} />
            )}
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                type="button"
                className="btn btn-default"
                onClick={this._onHide}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button
                type="submit"
                className={
                  (addTransferItemsForm &&
                    !addTransferItemsForm.items.length) ||
                  this.state.itemHasRecipe
                    ? `btn ${styles.disableBtnAddItem}`
                    : 'btn btn-primary'
                }
                disabled={
                  isItemAlreadyAdded ||
                  (addTransferItemsForm &&
                    !addTransferItemsForm.items.length) ||
                  this.state.itemHasRecipe
                }
              >
                Add
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _getNameItemSelected = () => {
    const { addItems } = this.props;
    const { selectValue } = this.state;
    const item = addItems.items.find(item => item.id === selectValue);

    return item.name;
  };

  // on this modal submit
  _onSubmit = values => {
    const { reset, onModalAddItems } = this.props;
    onModalAddItems(values.items);
    this.setState({ selectValue: null });
    reset();
  };

  _onHide = event => {
    event.preventDefault();
    event.stopPropagation();
    const { reset, onModalClickCancel } = this.props;
    this.setState({ selectValue: null });
    reset();
    onModalClickCancel();
  };

  _selectOnInputChange = value => {
    const { onModalSelectInputChange } = this.props;
    this.setState({ selectValue: null, keyword: value, itemHasRecipe: false });
    onModalSelectInputChange(value);
    this.props.reset();
  };

  // when Select onChange
  _selectOnChange = val => {
    const {
      onModalSelectChange,
      addItems,
      transferItemForm,
      searchForm,
    } = this.props;
    let hasRecipe = false;
    if (val) {
      onModalSelectChange(
        val.value,
        addItems.items,
        transferItemForm.transfers
      );
      this.setState({ selectValue: val.value });
      addItems.items.forEach(item => {
        if (item.id === val.value) {
          hasRecipe = item.is_recipe;
        }
      });

      if (hasRecipe && searchForm.namespace === NAMESPACE_ITEMS) {
        this.setState({ itemHasRecipe: true, keyword: '' });
      } else {
        this.setState({ itemHasRecipe: false, keyword: '' });
      }
    } else {
      this.setState({ selectValue: null });
      this.props.onModalGetFromInit();
    }
  };

  _selectOnClick = () => {
    this.setState({ keyword: '' });
    if (!this.state.selectValue) {
      this.props.onModalGetFromInit();
    }
  };

  _onSearchReachBottom = () => {
    this.props.onModalSearchReachBottom(this.state.keyword);
    this.setState({ keyword: '' });
  };

  _dismissError = () => {
    this.setState({ openErrorAlert: false });
  };

  _onErrorQuantity = () => {
    this.setState({ openErrorAlert: true });
    setTimeout(
      function() {
        this.setState({ openErrorAlert: false });
      }.bind(this),
      1000
    );
  };

  _renderField = (member, index, fields) => {
    const { searchForm } = this.props;
    const transferObject = fields.get(index);

    return (
      <div className="mk-grouped-input" key={index}>
        {searchForm &&
          searchForm.namespace === NAMESPACE_ITEMS &&
          transferObject.isItem && (
            <div className="form-group col-sm-4">
              <Field
                component={nameField}
                type={!transferObject.isItem ? 'hidden' : ''}
                name={`${member}.itemName`}
              />
            </div>
          )}
        {searchForm &&
          searchForm.namespace === NAMESPACE_ITEMS &&
          !transferObject.isItem && (
            <div className="form-group col-sm-4">
              <Field component={nameField} name={`${member}.itemVariantName`} />
            </div>
          )}

        {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS && (
          <div className="form-group col-sm-4">
            <Field component={nameField} name={`${member}.unitName`} />
          </div>
        )}

        <div className="form-group col-sm-4">
          <Field component={nameFieldDisabled} name={`${member}.inStock`} />
        </div>

        <div className="form-group col-sm-4" style={{ paddingRight: 0 }}>
          <Field
            component={SettingField}
            name={`${member}.quantity`}
            className="form-control"
            normalize={this._lessThanEqualInStock(index)}
            positiveNumberOnly
            maxFractionDigits={
              searchForm && searchForm.namespace === NAMESPACE_ITEMS ? 0 : 2
            }
          />
        </div>
      </div>
    );
  };

  _renderFieldArray = ({ fields }) => {
    const { searchForm, isItemAlreadyAdded } = this.props;
    const doms = [];

    if (fields.length) {
      doms.push(
        <table className={`${styles['table-header']} table table-truncate`}>
          <thead>
            <tr>
              {searchForm && searchForm.namespace === NAMESPACE_ITEMS && (
                <th className="text-center" width="30%">
                  {fields.length > 1 ? 'Variant' : 'Item'}
                </th>
              )}
              {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS && (
                <th className="text-center" width="30%">
                  Unit
                </th>
              )}
              <th className="text-center" width="30%">
                In Stock
              </th>
              <th className="text-center" width="30%">
                Transfer Quantity
              </th>
            </tr>
          </thead>
        </table>
      );
    }

    return (
      <div className={styles['list-item-input']}>
        {!this.state.itemHasRecipe &&
          !isItemAlreadyAdded &&
          this.state.selectValue && (
            <div className={styles['item-name']}>
              <span> {this._getNameItemSelected()} </span>
            </div>
          )}
        {doms}
        <div className={`row mk-grouped-list-input`}>
          <div className="col-xs-12">{fields.map(this._renderField)}</div>
        </div>
      </div>
    );
  };

  _lessThanEqualInStock = index => (value, previousValue, allValues) => {
    if (value) {
      // only allow number
      if (isNaN(value)) {
        return previousValue;
      }
      if (parseFloat(value) <= parseFloat(allValues.items[index].inStock)) {
        return value;
      }
      this._onErrorQuantity();
      return allValues.items[index].inStock < 0
        ? 0
        : allValues.items[index].inStock;
    }
    return value;
  };

  _hasMore = () => {
    const {
      addItems: { currentPage, totalPage },
    } = this.props;
    return currentPage < totalPage;
  };
}

const mapForm = {
  form: 'addTransferItems',
  touchOnBlur: true,
  touchOnChange: true,
  validate,
};

const connected = reduxForm(mapForm)(AddItemsModal);

export default connected;
